import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';

import { YEARS } from '../../../../../config/constants';
import { YearSelectorPropsType } from '../types';

const YearSelector = ({ newData, setNewData, changeViewMonths }: YearSelectorPropsType) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <label>Select Year</label>
      <Dropdown className="a-select" show={show} onToggle={show ? () => setShow(false) : () => setShow(true)}>
        <Dropdown.Toggle
          id="dropdown-date-compare-year"
          className={`btn-gray-l label-year-selector${newData.year !== 'Select' ? '-selected' : ''}`}
        >
          <label className={`label-label`}>{newData.year}</label>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <ul>
            {YEARS.map((year, index) => (
              <li key={year + '-' + index}>
                <div
                  onClick={() => {
                    changeViewMonths(new Date(year, 0, 1));
                    setNewData({
                      ...newData,
                      selectedDates: [],
                      year: year,
                      default: 'custom'
                    });
                    setShow(false);
                  }} className={'label-select-year'}
                >{year}</div>
              </li>
            ))}
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default YearSelector;